export class RfidLocation{
    Name: string;
    Id: number;
    Type: string;
    ExternalId: string;
}